import { useRegisterSW } from 'virtual:pwa-register/react';

import useFeatureFlags from '@cobliteam/hooks/src/useFeatureFlags';

import { Button } from '@cobliteam/ui/components';

const clientVersion = window.__DASHBOARD_MONOREPO_VERSION__;

function getUpgradeType(newVersion: string, oldVersion?: string) {
  if (!oldVersion) return 'noChange';

  const parseVersion = (version: string) => version.split('.').map(Number);

  const [oldMajor, oldMinor, oldPatch] = parseVersion(oldVersion);
  const [newMajor, newMinor, newPatch] = parseVersion(newVersion);

  if (newMajor > oldMajor) return 'major';
  if (newMinor > oldMinor) return 'minor';
  if (newPatch > oldPatch) return 'patch';

  return 'noChange';
}

function UpdateBanner() {
  const { updateBanner: updateBannerFlag, herbieDashboardVersion: herbieDashboardVersionFlag } = useFeatureFlags();
  const upgradeType = getUpgradeType(herbieDashboardVersionFlag, clientVersion);

  const {
    needRefresh: [needRefresh, setNeedRefresh],
    updateServiceWorker,
  } = useRegisterSW({
    onRegisteredSW(swUrl, r) {
      console.info(`Service Worker at: ${swUrl}`);
      r &&
        setInterval(
          () => {
            console.info('Checking for sw update');
            r.update();
          },
          5 * 60 * 1000 /* 5min  */
        );
    },
  });

  const onRefresh = () => {
    setNeedRefresh(false);
    updateServiceWorker(true);
  };

  if (updateBannerFlag === false) return null;
  if (upgradeType === 'noChange') return null;
  if (upgradeType === 'patch') return null;

  return (
    <div>
      {needRefresh && (
        <div
          className='fixed bottom-4 right-1/3 ml-[200px] shadow-xl bg-white m-2 border border-gray-light rounded-md p-4 w-[400px]'
          style={{
            zIndex: '9999',
          }}
        >
          <div className='flex justify-center items-center gap-4'>
            <div className='relative flex justify-between'>
              <div className=' text-gray-dark text-md'>Nova atualização disponível</div>
            </div>
            <div className='flex gap-2'>{needRefresh && <Button onClick={onRefresh}>Atualizar painel</Button>}</div>
          </div>
        </div>
      )}
    </div>
  );
}

export default UpdateBanner;
